

































































import Vue from "vue";

import store from "@/store";

import FooterCard from "../../cards/FooterCard.vue";
export default Vue.extend({
  name: "Footer",
  components: { FooterCard },
  computed: {
    numberOfAlgorithms() {
      return store.getters.algorithms.length;
    },
    numberOfLanguages() {
      return store.state.languages.length;
    },
    numberOfLinesOfCode() {
      return store.state.linesOfCode.summary.total;
    },
  },
});
